<template>
  <div class="d-custom-select" ref="select" tabindex="0" @blur="close">
    <div
      class="form-control d-flex justify-content-between align-items-center select-option cursor-pointer"
      @click="toggle"
    >
      <span v-if="value">
        <slot name="selected" :option="value">
          {{ getLabel(value) }}
        </slot>
      </span>
      <span v-else class="text-muted">
        {{ resolvedPlaceholder }}
      </span>
      <i
        class="fas select-chevron"
        :class="open ? 'fa-chevron-up' : 'fa-chevron-down'"
      />
    </div>
    <div v-if="open" class="dropdown-menu show w-100">
      <button
        v-for="option in options"
        :key="getKey(option)"
        type="button"
        class="dropdown-item select-option"
        @mousedown.prevent="select(option)"
      >
        <slot name="option" :option="option">
          {{ getLabel(option) }}
        </slot>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'custom-select',

  props: {
    value: {
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'label',
    },
    trackBy: {
      type: String,
      default: 'id',
    },
  },

  data() {
    return {
      open: false,
    };
  },

  computed: {
    resolvedPlaceholder() {
      return this.placeholder || this.$t('shared.select.placeholder');
    },
  },

  methods: {
    toggle() {
      this.open = !this.open;
    },
    close() {
      setTimeout(() => {
        this.open = false;
      }, 100);
    },
    select(option) {
      this.$emit('input', option);
      this.$emit('change', option);
      this.open = false;
    },
    getLabel(option) {
      return option[this.label];
    },
    getKey(option) {
      return option[this.trackBy];
    },
  },
};
</script>

<style scoped>
.d-custom-select {
  position: relative;
}

.cursor-pointer {
  cursor: pointer;
  user-select: none;
}

.form-control {
  display: flex;
  align-items: center;
  min-height: 38px;
}

.dropdown-menu {
  display: block;
  max-height: 250px;
  overflow-y: auto;
  margin-top: 2px;
  padding: 0.25rem 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
}

.dropdown-item:hover {
  background: #f8f9fa;
}

.select-chevron {
  font-size: 0.65rem;
  opacity: 0.7;
}

.select-option {
  font-size: 0.8rem;
  padding: 0.375rem 0.75rem;
}
</style>
